export class TrackingService {
  identifier: string;
  name: string;
}
